export default __webpack_public_path__ + "static/media/s6.c3a8506f.png";